import React from "react";
import { useTranslation } from "react-i18next";
import IconContainer from "@/components/ui/icon-container";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { InfoCircle } from "@dreamhub/designsystem/icons";
import { SlotFlag } from "./slotFlags";

export const SlotFlagMarker: React.FC<{ flag: SlotFlag }> = ({ flag }) => {
  const { t } = useTranslation();
  const label = t(`contracts.proposals.editor.slotFlags.${flag}`);
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          role="img"
          aria-label={label}
          // Focusable, so the tooltip also opens from the keyboard.
          tabIndex={0}
          className="flex"
          data-test={`proposal-slot-flag-${flag}`}
        >
          <IconContainer
            size="sm"
            as="span"
            className={
              flag === SlotFlag.UNSUPPORTED
                ? "text-text-negative shrink-0"
                : "text-text-warning shrink-0"
            }
          >
            <InfoCircle />
          </IconContainer>
        </span>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
};
